import { createAction, props } from '@ngrx/store';

/**
 * Fired when a new campaign is selected from the campaign select
 * This action is used to indicate that the campaign has changed
 * and can be used unsubscribe listens on a list page where the results
 * are dependent upon the campaign query param.
 *
 * For example, on the list view page, the component responsible for showing toplines
 * listens for changes on the campaignId query params.
 * When it detects this change, it attempts to fetch information for the person in the context
 * of the new campaign.
 *
 * However, when switching the campaign, the component is destroyed, but not before a request is sent
 * with the new campaign id.
 *
 * To solve this problem, the component can listen to this action to determine if it should
 * unsubscribe from the watch queries.
 *
 */
export const campaignSelectChangedAction = createAction('[Campaign Select Changed Action]', props<{
  campaignId: string;
}>());
